import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=deef9a5e"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deef9a5e')) {
      api.createRecord('deef9a5e', component.options)
    } else {
      api.reload('deef9a5e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=deef9a5e", function () {
      api.rerender('deef9a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/power-plant/edit.vue"
export default component.exports